<template>
  <main class="main-content" style="margin-top: 80px;">
    <Hero :title="heroTitle" :description="heroDescription" />
    <CompanyIntro />
    <WheelchairIntro />
    <Features :features="features" />
    
    <!-- Newsletter订阅区域 -->
    <section class="newsletter-section">
      <div class="container">
        <div class="newsletter-content">
          <div class="newsletter-text">
            <h2>Subscribe to Our Newsletter</h2>
            <p>Stay updated with our latest products, technology updates, and industry insights. Be the first to know about our innovative solutions.</p>
          </div>
          <div class="newsletter-form">
            <form @submit.prevent="subscribeNewsletter" class="subscribe-form">
              <div class="form-group">
                <input 
                  type="email" 
                  v-model="email" 
                  placeholder="Enter your email address"
                  class="email-input"
                  required
                />
                <button type="submit" class="subscribe-btn" :disabled="isSubmitting">
                  <span v-if="!isSubmitting">Subscribe</span>
                  <span v-else class="loading-spinner"></span>
                </button>
              </div>
              <div class="form-options">
                <label class="checkbox-item">
                  <input type="checkbox" v-model="agreeTerms" required>
                  <span>I agree to receive marketing emails</span>
                </label>
              </div>
            </form>
            <div v-if="subscribeMessage" :class="['subscribe-message', subscribeStatus]">
              {{ subscribeMessage }}
            </div>
          </div>
        </div>
      </div>
    </section>
    
    <Products :products="products" />
    <About :aboutText1="aboutText1" :aboutText2="aboutText2" />
  </main>
</template>

<script>
import Hero from '../components/Hero.vue';
import Features from '../components/Features.vue';
import Products from '../components/Products.vue';
import About from '../components/About.vue';
import CompanyIntro from '../components/CompanyIntro.vue';
import WheelchairIntro from '../components/WheelchairIntro.vue';

export default {
  name: 'Home',
  components: { Hero, Features, Products, About, CompanyIntro, WheelchairIntro },
  data() {
    return {
      heroTitle: 'Innovative Technology for Better Living',
      heroDescription: 'We are dedicated to creating advanced assistive solutions that enrich the lives of people with disabilities, enabling independent living and a better quality of life.',
      aboutText1: "With the development of the domestic rehabilitationequipment market, the company successively established SIWEEClRehabilitation Equipment (Jiangsu) Co. Ltd onJanuary 1,2020, and FALNKEEF(Suzhou) Health TechnologyCo., Ltd in2023,focusing on product research anddevelopment,export and Al intelligent internet electricwheelchair,ultra-light carbon fibrewheelchair、decompression rehabilitation wheelchair and lightweightportable scooter.Siweeci has compliant factories inChangzhou, Zhejiang,Guangzhou, Suzhou and other production bases in China.Carrying excellent R&D and manufacturing ofSiweeciproducts! At the meantime, Siweeci has been progressivelyexpandingits foreign trade export business, customersfromUnited States, Britain, Türkiye, Spain, Dubai and othercountries, and we have maintained good long-termcooperativerelations.Nowadays,the company's product range has expanded toinclude medical equipment related products such asmanualwheelchairs,electric wheelchairs, scooters, climbingmachines and oxygen concentrators. Our research anddevelopmentcentre located in Suzhou, Siweeci Companywelcomes your arrival, where you can always find a productthat suits you!",
      aboutText2: '',
      email: '',
      agreeTerms: false,
      isSubmitting: false,
      subscribeMessage: '',
      subscribeStatus: '',
      features: [
        { id: 1, icon: '🔬', title: 'Innovation', description: 'Utilizing cutting-edge technology to develop innovative products that provide advanced solutions.' },
        { id: 2, icon: '🛡️', title: 'Safety & Reliability', description: 'Strict quality control system ensuring product safety and reliability for peace of mind.' },
        { id: 3, icon: '👥', title: 'User-Centered', description: 'Deep understanding of user needs, providing personalized customization services.' },
        { id: 4, icon: '🌟', title: 'Premium Service', description: 'Professional pre-sales consultation and after-sales service team providing comprehensive support.' }
      ],
      products: [
        { id: 1, name: 'W02', description: '1.Untra light , cost performance of carbon fiber,2.Fully automatic electromagnetic brake', img: 'https://onbotics-map-img.oss-cn-shanghai.aliyuncs.com/w1.png' },
        { id: 2, name: 'W02W widened', description: 'FEATURE:1 .Untra light , cost performance of carbon fiber2.Fully automatic electromagnetic brake3.The handrail can be turned down', img: 'https://onbotics-map-img.oss-cn-shanghai.aliyuncs.com/w2.png' },
        { id: 3, name: '208 FDA510K', description: 'FEATURE:1.Untra light , Folding easily for taking by one person2.Electromagnetic brake3.Controller with Led light', img: 'https://onbotics-map-img.oss-cn-shanghai.aliyuncs.com/w3.png' },
        { id: 4, name: '205 FDA510K', description: 'FEATURE:1. Untra light, Folding easily for taking by one person2.Electromagnetic brake3. Folding width is only 26cm', img: 'https://onbotics-map-img.oss-cn-shanghai.aliyuncs.com/w4.png' },
        { id: 5, name: '205M FDA510K', description: 'FEATURE:1. Untra light, Folding easily for taking by one person2. Electromagnetic brake3. Folding width is only 26cm', img: 'https://onbotics-map-img.oss-cn-shanghai.aliyuncs.com/w5.png' }
      ]
    }
  },
  mounted() {
    this.initScrollAnimations();
    this.initSmoothScroll();
  },
  methods: {
    initScrollAnimations() {
      const observerOptions = {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-on-scroll');
          }
        });
      }, observerOptions);

      // 观察需要动画的元素
      document.querySelectorAll('.feature-card, .product-card, .about-content').forEach(el => {
        observer.observe(el);
      });
    },
    initSmoothScroll() {
      // 平滑滚动
      document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
          e.preventDefault();
          const target = document.querySelector(this.getAttribute('href'));
          if (target) {
            target.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        });
      });
    },
    async subscribeNewsletter() {
      if (!this.email || !this.agreeTerms) {
        this.showMessage('Please enter your email address and agree to the terms', 'error');
        return;
      }

      this.isSubmitting = true;
      
      try {
        // Simulate API call
        await new Promise(resolve => setTimeout(resolve, 1000));
        
        // Here you can add actual API call
        // const response = await fetch('/api/newsletter/subscribe', {
        //   method: 'POST',
        //   headers: { 'Content-Type': 'application/json' },
        //   body: JSON.stringify({ email: this.email })
        // });
        
        this.showMessage('Subscription successful! Thank you for your interest. We will send you the latest updates regularly.', 'success');
        this.email = '';
        this.agreeTerms = false;
      } catch (error) {
        this.showMessage('Subscription failed, please try again later.', 'error');
      } finally {
        this.isSubmitting = false;
      }
    },
    
    showMessage(message, status) {
      this.subscribeMessage = message;
      this.subscribeStatus = status;
      
      setTimeout(() => {
        this.subscribeMessage = '';
        this.subscribeStatus = '';
      }, 5000);
    }
  }
}
</script> 

<style scoped>
/* Newsletter区域 */
.newsletter-section {
  background: linear-gradient(135deg, #2c5aa0 0%, #4a7bc8 100%);
  padding: 4rem 0;
  color: white;
  text-align: center;
}

.newsletter-content {
  max-width: 600px;
  margin: 0 auto;
}

.newsletter-text h2 {
  font-size: 2.5rem;
  margin-bottom: 1rem;
  font-weight: 300;
}

.newsletter-text p {
  font-size: 1.1rem;
  opacity: 0.9;
  margin-bottom: 2rem;
  line-height: 1.6;
}

.newsletter-form {
  max-width: 400px;
  margin: 0 auto;
}

.subscribe-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.form-group {
  display: flex;
  gap: 0.5rem;
}

.email-input {
  flex: 1;
  padding: 1rem;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  outline: none;
}

.email-input:focus {
  box-shadow: 0 0 0 3px rgba(255,255,255,0.2);
}

.subscribe-btn {
  background: #2c5aa0;
  color: white;
  border: none;
  padding: 1rem 2rem;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 100px;
}

.subscribe-btn:hover:not(:disabled) {
  background: #1e3a5f;
  transform: translateY(-2px);
}

.subscribe-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.loading-spinner {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid transparent;
  border-top: 2px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.form-options {
  text-align: left;
}

.checkbox-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
  opacity: 0.9;
  cursor: pointer;
}

.checkbox-item input[type="checkbox"] {
  width: 16px;
  height: 16px;
  accent-color: #2c5aa0;
}

.subscribe-message {
  margin-top: 1rem;
  padding: 0.8rem;
  border-radius: 8px;
  font-size: 0.9rem;
}

.subscribe-message.success {
  background: rgba(76, 175, 80, 0.2);
  color: #4caf50;
  border: 1px solid rgba(76, 175, 80, 0.3);
}

.subscribe-message.error {
  background: rgba(244, 67, 54, 0.2);
  color: #f44336;
  border: 1px solid rgba(244, 67, 54, 0.3);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .newsletter-text h2 {
    font-size: 2rem;
  }
  
  .form-group {
    flex-direction: column;
  }
  
  .subscribe-btn {
    width: 100%;
  }
}
</style> 